<template>
    <div class="wrap-position-history">
        <header-app></header-app>
        <div class="history-banner"></div>
        <div class="history-detail animation" >
            <ul class="history-detail-list">
                <li class="history-detail-item" v-for="(item,index) in list" :key="index">
                    <div class="history-year">
                        <span class="circle"></span>
                    </div>
                    <div class="info-wrap">
                        <h3 class="info-years">{{item.title}}</h3>
                        <div class="history-info">
                            <div class="info-pic">
                                <img :src="item.imgs[0]">
                            </div>
                            <div class="info-article" v-html="item.content"></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <bottom-app></bottom-app>
        <top-scroll></top-scroll>
    </div>
</template>

<script>
    import bottomApp from '@/components/bottomApp.vue'
    import topScroll from '@/components/topScroll.vue'
    import headerApp from '@/components/headerApp.vue'
    export default {
        components: {
            headerApp,
            bottomApp,
            topScroll
        },
        data(){
            return{
                list:[]
            }
        },
        created(){
            this.$api.historyList().then((res)=>{
                if(res){
                    this.list = res.list || []
                }
            })
        }
    }
</script>

<style lang="less" rel="stylesheet/less">
    .wrap-position-history{
        .history-banner{
            width: 100%;
            height:3rem;
            background: url(../../assets/imgs/tp-history-bg.jpg) no-repeat top center;
            background-size: auto 100%;
        }
        .history-detail{
            padding: .4rem;
            .history-detail-list{
                display: block;
                position: relative;
                .history-detail-item{
                    display: flex;
                }
                .history-year{
                    width: 0.6rem;
                    position: relative;
                    &:before{
                        content: "";
                        position: absolute;
                        top: .6rem;
                        left: 50%;
                        margin-left: -1.5px;
                        width: 3px;
                        background: #bfbfbf;
                        height: 100%;
                    }
                    .circle{
                        content: "";
                        position: absolute;
                        top: 0.22rem;
                        left: 50%;
                        margin-left: -.13rem;
                        width: 0.26rem;
                        height: 0.26rem;
                        border-radius: 50%;
                        background: #ed1d25;
                        &:after{
                            content: "";
                            position: absolute;
                            top: -50%;
                            right: -50%;
                            width: 0.5rem;
                            height: 0.5rem;
                            border-radius: 50%;
                            background: #ed1d25;
                            opacity: 0.5;
                        }
                    }
                }
                .info-wrap{
                    flex: 1;
                    margin-left: .2rem;
                    .info-years{
                        height: .7rem;
                        line-height: .7rem;
                        font-size: .36rem;
                        color: #ed1d25;
                        font-weight: bold;
                        text-align: left;
                    }
                    .history-info{
                        display: block;
                        width: 5.7rem;
                        background-color: rgb(255, 255, 255);
                        box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.15);
                        padding: .5rem .22rem;
                        text-align: left;
                        box-sizing: border-box;
                        .info-pic{
                            img{
                                width: 100%;
                                height: auto;
                            }
                        }
                        .info-article{
                            color: #2d2d2d;
                            font-size: .28rem;
                            line-height: 1.5;
                            padding-top: .5rem;
                        }
                    }
                }
            }
        }
    }
</style>
